import { Suspense } from 'react';
import { createCrumbHandle } from '../../utilities/auth';
import Loader from '../../globalComponents/loader/DPLoader';
import { ANALYTICS_RULES, access, param } from '../../access';
import BatchConfigListing from '../../pages/BatchConfig/components/BatchConfigListing';
import CreateEditBatchConfigPage from '../../pages/BatchConfig/components/CreateEditBatchPage';


const batchConfigRoute = [
  {
    path: '/batch-config/:assetId',
    handle: createCrumbHandle('Batch Config'),
    children: [
      {
        index: true,
        element: (
          <Suspense fallback={<Loader />}>
            <BatchConfigListing />
          </Suspense>
        ),
        handle: access(ANALYTICS_RULES.batches, param('assetId')),
      },
      {
        path: "createEditBatchConfig/:batchConfigurationId?",
        index: true,
        element: (
          <Suspense fallback={<Loader />}>
            <CreateEditBatchConfigPage />
          </Suspense>
        ),
        handle: { ...createCrumbHandle('Create Batch Config'), ...access(ANALYTICS_RULES.manageBatches, param('assetId')) },
      }
    ]
  },
];

export default batchConfigRoute;
